export enum UserRightsCopierFormFields {
    FROM_USER = 'fromUser',
    TO_USER = 'toUser',
    FROM_USER_GROUP = 'fromUserGroup',
    TO_USER_GROUP = 'toUserGroup',
}
